var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      ref: "newPopover",
      attrs: {
        title: _vm.form.id ? "修改" : "新增",
        visible: _vm.dialogShow,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogShow = $event
        },
        close: function($event) {
          return _vm.clearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "110px" }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "电话", prop: "phone" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入标题" },
                model: {
                  value: _vm.form.phone,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "phone", $$v)
                  },
                  expression: "form.phone"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "邮箱", prop: "email" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入标题" },
                model: {
                  value: _vm.form.email,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "email", $$v)
                  },
                  expression: "form.email"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "地址", prop: "site" }
            },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "请输入标题" },
                model: {
                  value: _vm.form.site,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "site", $$v)
                  },
                  expression: "form.site"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "语言", prop: "language" }
            },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.form.language,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "language", $$v)
                    },
                    expression: "form.language"
                  }
                },
                _vm._l(_vm.language, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.dialogShow = false
                }
              }
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "info" },
              on: {
                click: function($event) {
                  return _vm.clearData(true)
                }
              }
            },
            [_vm._v("重置")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.submitData()
                }
              }
            },
            [_vm._v("提交")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }